import Utils from '../../modules/utils'

const saveNote = (contactIds, text, filename, callbackFunc) => {
  const url = 'contact_notes'
  const data = {contactIds, text, filename}
  Utils.post(url, data, callbackFunc)
}

export {saveNote}
